class AbortableRequest {
  constructor(path, options) {
    this.controller = new AbortController();
    // WORKAROUND: In Jest with jest-fixed-jsdom, jsdom's AbortSignal isn't compatible
    // with Node's native fetch, causing "Expected signal to be an instance of AbortSignal" errors.
    // Skip signal in tests until upstream is fixed.
    // Tracking: https://github.com/mswjs/jest-fixed-jsdom/issues/37
    //           https://github.com/jsdom/jsdom/issues/3682
    const useSignal = typeof __JEST__ === 'undefined';
    this.request = fetch(path, {
      ...options,
      ...(useSignal ? { signal: this.controller.signal } : {})
    });
  }

  abort() {
    this.controller.abort();
  }

  async then(callback) {
    try {
      const response = await this.request;

      if (response.status === 401) {
        window.location.reload();
        return new Promise(() => {}); // Prevent further execution while reloading
      }

      const error = response.ok ? null : new Error(`Error: ${response.status} error`);
      const responseBody = await response.text();
      const body = responseBody.length ? JSON.parse(responseBody) : undefined;

      return callback(error, { body, status: response.status });
    } catch (error) {
      return callback(error, null);
    }
  }
}

export default AbortableRequest;
